import React from 'react';
import { motion } from 'framer-motion';
import { Button } from './ui/Button';
import { ArrowRight } from 'lucide-react';
export function HeroSection() {
  const scrollToCta = () => {
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="relative min-h-[85vh] flex flex-col justify-center bg-[#0f1923] text-[#f0ebe3] pt-20 pb-12 overflow-hidden" data-id="element-43">
      {/* Background subtle texture/gradient */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-[#1a2740] via-[#0f1923] to-[#0f1923] opacity-50" data-id="element-44" />

      <div className="container mx-auto px-6 relative z-10 max-w-6xl" data-id="element-45">
        <div className="grid lg:grid-cols-2 gap-12 items-center" data-id="element-46">
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          duration: 0.8,
          ease: 'easeOut'
        }} className="space-y-6" data-id="element-47">
            {/* Emotional Lead */}
            <div className="space-y-3 border-l-2 border-[#c9a84c]/30 pl-6 italic text-gray-400 text-lg" data-id="element-48">
              <p data-id="element-49">Hay una escena que se repite en demasiadas casas.</p>
              <p data-id="element-50">Son las 7:30–9:30pm.</p>
              <p data-id="element-51">
                Tú ya no tienes energía. Solo quieres que cenen, que se bañen,
                que duerman.
              </p>
              <p className="text-[#c9a84c]" data-id="element-52">
                Y entonces dices una frase pequeña: "Ya apaga."
              </p>
            </div>

            <div className="space-y-3" data-id="element-53">
              <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold font-serif leading-tight text-white" data-id="element-54">
                Apagar el celular no debería terminar en{' '}
                <span className="text-[#c9a84c]" data-id="element-55">discusiones</span>.
              </h1>
              <p className="text-xl text-gray-300 leading-relaxed max-w-xl" data-id="element-56">
                Plan Anti-Pantalla 30 Días — Recupera la paz y el liderazgo sin
                convertirte en el "policía" de tu hogar.
              </p>
            </div>

            <div className="flex flex-col sm:flex-row gap-4 pt-2" data-id="element-57">
              <Button onClick={() => document.getElementById('comprar')?.scrollIntoView({
              behavior: 'smooth'
            })} className="group" data-id="element-58">
                Quiero el Plan Anti-Pantalla
                <ArrowRight className="ml-2 w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-59" />
              </Button>
            </div>

            <p className="text-sm text-gray-500" data-id="element-60">
              *Descarga digital inmediata. Empieza esta misma noche.
            </p>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.8,
          delay: 0.2
        }} className="relative" data-id="element-61">
            <div className="relative z-10 rounded-xl overflow-hidden shadow-2xl shadow-[#c9a84c]/10 border border-[#1a2740]" data-id="element-62">
              <img src="https://cdn.magicpatterns.com/uploads/8Xmh8nvyuQfKczEyxCfCW8/mockoup_3.png" alt="Plan Anti-Pantalla 30 Días en tablet" className="w-full h-auto object-cover" data-id="element-63" />
            </div>
            {/* Decorative elements */}
            <div className="absolute -top-10 -right-10 w-64 h-64 bg-[#c9a84c]/10 rounded-full blur-3xl" data-id="element-64" />
            <div className="absolute -bottom-10 -left-10 w-64 h-64 bg-[#1a2740] rounded-full blur-3xl" data-id="element-65" />
          </motion.div>
        </div>
      </div>
    </section>;
}